/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdQRCodeProps } from './type';

export const qRCodeDefaultProps: TdQRCodeProps = {
  borderless: false,
  iconSize: 40,
  level: 'M',
  size: 160,
  status: 'active',
  type: 'canvas',
};
